var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _vm.loggedIn
        ? [
            _vm.ordersToRun.length > 0
              ? _vm._l(_vm.ordersToRun, function(order) {
                  return _c("div", [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-lg-3" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-white bg-white cmp-product-thumb p-3"
                          },
                          [
                            _c("div", [
                              _c("b", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.contactOrderId"
                                    )
                                  )
                                }
                              }),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(order.id) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("b", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.orderConfirmationDate"
                                    )
                                  )
                                }
                              }),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("moment")(
                                      order.createdAt,
                                      "DD.MM.YYYY"
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-lg-9 mt-2 mt-lg-0" },
                        [
                          _c(
                            "ul",
                            { staticClass: "product-list row grid" },
                            [
                              _vm._l(order.orderItems, function(item) {
                                return [
                                  _c(
                                    "li",
                                    {
                                      staticClass:
                                        "col-12 col-sm-6 col-md-3 col-lg-3"
                                    },
                                    [
                                      _c("category-item", {
                                        attrs: {
                                          "item-data": item.data,
                                          "decimal-count":
                                            _vm.$ceres.config.item.storeSpecial,
                                          "disable-carousel-on-mobile": false
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("hr")
                  ])
                })
              : [
                  _c("div", { staticClass: "bg-white cmp-product-thumb p-4" }, [
                    _c("div", { staticClass: "text-center fs-110" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "Bigtex5::Template.meinbigtexNoItemBought"
                          )
                        )
                      )
                    ])
                  ])
                ]
          ]
        : [
            _c("div", { staticClass: "bg-white cmp-product-thumb p-4" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("div", { staticClass: "h3 mb-4" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Bigtex5::Template.meinbigtexWhatIsIt")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate("Bigtex5::Template.meinbigtexText")
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("hr", { staticClass: "d-lg-none" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "h3 mb-4" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Bigtex5::Template.meinbigtexLogin")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("login")
                  ],
                  1
                )
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }